import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import {ValidatonError} from '../resources/GenericResource';


const ForgotPasswordChangeFormModel = t.struct({
    password: t.Str,
    password_confirm: t.Str
});

function formLayout(locals){
    let renderedInputs = Object.keys(locals.inputs).map(function(key){
        return fieldLayout(locals.inputs[key]);
    });
    return (
        <div>
            {renderedInputs}
        </div>
    );
}

function fieldLayout(field){
    return (
        <label className="form-control form-control-text">
            {field}
        </label>
    );
}

const Form = baseFormFactory(ForgotPasswordChangeFormModel, true, true);

class ForgotPasswordChangeForm extends Form {
    constructor(props) {
        super(props);

        this.state = {
            value: props.originalFormData
        }
    }

    getValue() {
        return this.refs.form.getValue();
    }

    getOptions() {
        var retrievePasswordError = this.props.retrievePasswordError;

        return {
            auto: 'placeholders',
            hasError: !!retrievePasswordError,
            template: formLayout,
            fields: {
                password: {
                    type: 'password',
                    hasError: !!retrievePasswordError,
                    error: retrievePasswordError && retrievePasswordError['password'] ? 'This field is requiered.' : null 
                },

                password_confirm: {
                    type: 'password',
                    hasError: !!retrievePasswordError,
                    error: (retrievePasswordError && retrievePasswordError['password_confirm'] ? 'This field is requiered.' : null) || retrievePasswordError.error ? 'Password mismatch' : null
                }

            }
        };
    }

    render() {
        return (
            <t.form.Form ref="form" value={this.state.value} type={ForgotPasswordChangeFormModel} options={this.getOptions()} onChange={this.onChange.bind(this)} />
        );
    }
}

ForgotPasswordChangeForm.propTypes = {
    originalFormData: React.PropTypes.object.isRequired,
    retrievePasswordError: React.PropTypes.instanceOf(ValidatonError)
};

export default ForgotPasswordChangeForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ForgotPasswordChangeForm.js
 **/